import React from "react";

import { RECAP_SPRITE } from "./sprite";

export const Icon = ({ name }) => (
  <svg viewBox="0 0 512 512" aria-hidden="true">
    <use href={`#rc-${name}`} />
  </svg>
);

export const Sprite = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute" }}
    aria-hidden="true"
    /* Contenu statique extrait du design, voir sprite.js. */
    dangerouslySetInnerHTML={{ __html: `<defs>${RECAP_SPRITE}</defs>` }}
  />
);
